import { Dialog, Paper, PaperProps } from "@material-ui/core";
import { animated, config, useSpring } from "@react-spring/web";
import React, { PropsWithChildren } from "react";

const AnimatedPaper = animated(Paper);

type Props = {
  open: boolean;
  onClose: () => void;
  fullscreen: boolean;
  "cw-id"?: string;
};

export function ModalDialog({
  open,
  onClose,
  fullscreen,
  children,
  "cw-id": cwId,
}: PropsWithChildren<Props>) {
  const animatedStyles = useSpring({
    opacity: open ? 1 : 0,
    scale: open ? 1 : 0.83,
    config: config.stiff,
  });

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullScreen={fullscreen}
      disableRestoreFocus
      disableScrollLock
      PaperComponent={AnimatedPaper as React.ComponentType<PaperProps>}
      PaperProps={{
        style: {
          // PaperProps wants CSS properties so must cast the animated values to number
          scale: (animatedStyles.scale as unknown) as number,
          opacity: (animatedStyles.opacity as unknown) as number,
          visibility: open ? "visible" : "hidden",
        },
        // FIXME: Standardize drop shadow
        className:
          "cw-pt-2 cw-pb-4 cw-px-5 cw-min-w-[320px] cw-shadow-[0px_4px_14px_rgba(0,0,0,0.25)] cw-h-full sm:cw-h-auto",
      }}
      BackdropProps={{ style: { backgroundColor: "unset" } }}
      cw-id={cwId}
    >
      {children}
    </Dialog>
  );
}
